import PropTypes from 'prop-types';

export const LogoPropTypes = {
  logowidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logoheight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  logoType: PropTypes.oneOf(['header', 'footer', 'custom']).isRequired,
  customPath: PropTypes.string,
  href: PropTypes.string,
  alt: PropTypes.string, // String type for alt text
};

export const LogoDefaultProps = {
  logowidth: '100',
  logoheight: '100',
  logoType: 'header',
  href: '/',
  alt: '', // Default to empty string
};
